import { XMarkIcon } from '@heroicons/react/24/outline';
import DialogsAPI from "api/DialogsAPI";
import TrackingAPI from "api/TrackingAPI";
import generate_icon from 'assets/generate-message.svg';
import retry_icon from 'assets/rotate.svg';
import clsx from "clsx";
import styled from "styled-components";
import { errorAlert, successAlert } from 'ui-kit/Alert';
import Spinner from 'ui-kit/Spinner';

const MessageActions = (props) => {
  const {
    isNarrator,
    isLastBatchAndIsFirstMessage,
    sending,
    addingMore,
    canEdit,
    isRegenerating,
    loading,
    userMessage,
    setIsRegenerating,
    dialog,
    setUpdT,
    game,
    scenario,
    checkIfBlockers,
    setDeletingIndex,
    setAddingMore,
    scrollToBottom,
    batches,
    setBatches,
    setTempText,
    setNewMessageText,
    canGenerateMore,
    batch
  } = props;

  const analyticsData = {
    scenario: game?.alias,
    config_name: scenario?.name,
    scenario_name: game?.name,
    dialogId: dialog?.id
  };

  const handleRegenerateClick = async () => {
    if (checkIfBlockers('regenerate_message_click')) return;
    setIsRegenerating(true);
    try {
      await DialogsAPI.regenerateLastDialogBatch(dialog?.id);
      setUpdT(+new Date());
      successAlert('Message has been regenerated');
      TrackingAPI.trackEvent('message_regenerated', analyticsData);
    } catch {
      errorAlert('Error regenerating message. Please try again');
      TrackingAPI.trackEvent('error_message_regenerated', analyticsData);
    } finally {
      setIsRegenerating(false);
    }
  };

  const handleDeleteClick = async () => {
    if (checkIfBlockers('delete_message_click') || sending) {
      errorAlert('Please wait until the current message is sent');
      return;
    }
    setDeletingIndex(batch?.batchIndex);
  };

  const handleGenerateMoreClick = async () => {
    if (checkIfBlockers('dialog_generate_more_click') || addingMore) return;
    setNewMessageText('');
    setAddingMore(true);
    try {
      const pld = await DialogsAPI.continueDialog(dialog?.id, '');
      setTempText(undefined);
      TrackingAPI.trackEvent('no_input_message', analyticsData);
      const newBatch = pld?.batch;
      setBatches([...batches, newBatch]);
      scrollToBottom();
    } catch (exc) {
      const errorMsg = exc?.response?.data?.message?.includes('restart')
        ? 'To continue, please restart the dialog'
        : 'Error sending message. Please try again';
      errorAlert(errorMsg);
      TrackingAPI.trackEvent('no_input_message_error', analyticsData);
    } finally {
      setAddingMore(false);
    }
  };


  if (!isLastBatchAndIsFirstMessage || sending) return null;
  return (
    <div
      className={clsx(
        isNarrator ? 'justify-start' : 'justify-center',
        'flex flex-row flex-wrap items-center gap-2 pl-3'
      )}
    >
      {!addingMore && canEdit && (
        <RegenerateImage
          src={retry_icon}
          alt="regenerate image"
          className={clsx({ 'rotate-image': isRegenerating || loading })}
          onClick={handleRegenerateClick}
        />
      )}

      {userMessage === '' && !addingMore && canEdit && (
        <XMarkIcon
          className="h-6 w-6 cursor-pointer stroke-2 text-[rgb(169,169,169)] hover:opacity-80"
          onClick={handleDeleteClick}
        />
      )}

      {addingMore && <Spinner size={18} />}

      {canGenerateMore && !addingMore && canEdit && (
        <MoreImg src={generate_icon} alt="Generate more" onClick={handleGenerateMoreClick} />
      )}
    </div>
  );
};

export default MessageActions;

const RegenerateImage = styled.img`
  cursor: pointer;
  min-height: 16px;
  min-width: 16px;
  opacity: 1;
  :hover {
    opacity: 0.8;
  }
`;

const MoreImg = styled.img`
  cursor: pointer;
  height: 20px;
  :hover {
    opacity: 0.8;
  }
`;
